import { ERROR, LOADING, READY, useVisualState } from '../../../hooks/useVisualState'
import { useHistory, useParams } from 'react-router-dom'
import React, { useCallback, useEffect } from 'react'
import TeamCard from '../../../components/Cards/TeamCard/TeamCard'
import { oldGet, oldPost } from '../../../helpers/requestOld'
import './CompetitionView.scss'
import LoadingPanel from '../../../components/Loading/LoadingPanel'
import Button from '../../../components/Button/Button'
import Panel from '../../../components/Panel/Panel'
import useForceUpdate from '../../../hooks/useForceUpdate'

const CompetitionView = () => {
  const history = useHistory()
  const { competitionId } = useParams()
  const [[competitionState, competition], setCompetition] = useVisualState()
  const [update, forceUpdate] = useForceUpdate()

  const handleOpenTeam = useCallback((team_id) => {
    history.push('/soccer/competition/' + competitionId + '/team/' + team_id)
  }, [history, competitionId])

  const handleCloseRegister = useCallback(() => {
    oldPost('/cm/categories/' + competitionId + '/register_season', { open: false })
      .then(forceUpdate)
  }, [competitionId])

  const handleOpenRegister = useCallback(() => {
    oldPost('/cm/categories/' + competitionId + '/register_season', { open: true })
      .then(forceUpdate)
  }, [competitionId])

  useEffect(() => {
    setCompetition(LOADING)
    oldGet('/cm/categories/' + competitionId)
      .then((response) => {
        setCompetition(READY, response)
      })
      .catch((error) => {
        setCompetition(ERROR, error)
      })
  }, [setCompetition, competitionId, update])

  return (
    <div className="main-content competition-view-page">
      <div className="-page-header">
        <div className="-title">
        <div className="-left label-display-medium-semibold">{competition?.name}</div>
          <div className="-left proper-noun-small-medium">Competición</div>
        </div>
      </div>
      <div className="-content">
        <div className="label-display-small-semibold">Registro de Jugadores</div>
        <div className='-register-season'>
          <Panel>
            <div className='-action'>
              {competitionState === READY && competition?.registerOpen &&
                <>
                  <div>El registro de jugadores esta ABIERTO.</div>
                  <Button
                    label="Cerrar registro de jugadores"
                    size='field-sized'
                    onClick={handleCloseRegister}
                  />
                </>
              }
              {competitionState === READY && !competition?.registerOpen &&
                <>
                  <div>El registro de jugadores esta CERRADO.</div>
                  <Button
                    label="Abrir registro de jugadores"
                    size='field-sized'
                    onClick={handleOpenRegister}
                  />
                </>
              }
            </div>
          </Panel>
        </div>
        <div className="label-display-small-semibold">Equipos</div>
        <div className='-teams'>
          {competitionState === READY && competition?.teams && competition?.teams.map((team) => (
            <TeamCard
              key={team.team_id}
              name={team.name}
              logo={team.logo}
              tags={[team.short_name]}
              players={team.players}
              staff={team.staff}
              delegates={team.delegates}
              categoryName={competition.name}
              categoryLogo={competition.logo}
              onClick={() => handleOpenTeam(team.team_id)}
            />
          ))}
          {competitionState === READY && competition?.teams?.length === 0 &&
            <div>
              <div className="caption-default-medium">No hay equipos registrados.</div>
            </div>          
          }
        </div>
        {competitionState === LOADING && <LoadingPanel/>}
      </div>
    </div>
  )
}

export default CompetitionView
